import { render, staticRenderFns } from "./EmergencyContactsStep.vue?vue&type=template&id=a389bff4"
import script from "./EmergencyContactsStep.vue?vue&type=script&lang=js"
export * from "./EmergencyContactsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports